import React from "react";
import Header from "./header/header";
import Footer from "./footer/footer";

const WrapperLayout = ({ children }: any) => {
  return (
    <>
      <Header />
      <div style={{ minHeight: "100vh" }}>{children}</div>
      <Footer />
    </>
  );
};

export default WrapperLayout;
